/**
 * Defer calendar month invalidation while the user is on the menu tab.
 * Each menu save used to invalidate calendar immediately; with bottom tabs the
 * Calendar screen stays mounted and refetched on every +/- → 429s.
 */
import type { QueryClient } from '@tanstack/react-query';
import { ensureAsciiDateString } from '../../shared/utils/apiParams';
import { keys, monthFromDateYmd } from './keyRegistry';

function pendingKey(customer_id: number, month_ym: string): string {
  return `${customer_id}|${month_ym}`;
}

const pending_calendar_months = new Set<string>();

export function deferCalendarRefreshAfterMenuSave(customer_id: number, date: string): void {
  if (!customer_id || !date) {
    return;
  }
  const date_ascii = ensureAsciiDateString(date) || date;
  if (date_ascii.length < 7) {
    return;
  }
  pending_calendar_months.add(pendingKey(customer_id, monthFromDateYmd(date_ascii)));
}

export async function flushDeferredCalendarRefresh(
  query_client: QueryClient,
  customer_id: number,
): Promise<void> {
  if (!customer_id) {
    return;
  }
  const prefix = `${customer_id}|`;
  const months: string[] = [];
  for (const key of pending_calendar_months) {
    if (key.startsWith(prefix)) {
      months.push(key.slice(prefix.length));
      pending_calendar_months.delete(key);
    }
  }
  if (months.length === 0) {
    return;
  }
  const customer_keys = keys.customer(customer_id);
  await Promise.all(
    months.map(month_ym =>
      query_client.invalidateQueries({
        queryKey: customer_keys.calendar(month_ym),
      }),
    ),
  );
}
